import { i18n } from '@/locales';
const { t } = i18n;
const lc = 'views.worker.worker_profit_detail_dialog.table_header.';
export const workerProfitDetailDialogTableHeader = [
    {
        title: t(`${lc}created_at`),
        value: 'formattedCreatedAt',
        width: 150,
        align: 'center',
    },
    {
        title: t(`${lc}worker_baromoney_type_detail`),
        value: 'formattedWorkerBaromoneyTypeDetail',
        width: 150,
        key: 'workerBaromoneyTypeDetail',
        sortable: true,
        align: 'center',
    },
    {
        title: t(`${lc}transaction_baromoney`),
        value: 'formattedTransactionBaromoney',
        width: 90,
        align: 'center',
    },
    {
        title: t(`${lc}balance_baromoney`),
        value: 'formattedBalanceBaromoney',
        width: 150,
        align: 'center',
    },
    {
        title: t(`${lc}worker_baromoney_memo`),
        value: 'formattedWorkerBaromoneyMemo',
        width: 450,
        align: 'center',
    },
    {
        title: t(`${lc}order_id`),
        value: 'formattedOrderId',
        width: 90,
        align: 'center',
    },
    {
        title: t(`${lc}created_by`),
        value: 'formattedCreatedBy',
        width: 90,
        align: 'center',
    },
];
